import axios from "axios";
import services from "@/config/services";
import authHeader from "../auth/auth-header";
import Cookies from "js-cookie";
import FileManager from "@/services/ask-file-manager/index.js";

export default class SmsTemplateService {
  static interceptorSet = false;
  constructor(eventBus) {
    this.eventBus = eventBus;
    this.praticheUrl = `${services.ask_pratiche_base.url}`;
    this.filemanager = new FileManager();

    axios.interceptors.request.use((req) => {
      req.headers["Authorization"] = authHeader();
      req.headers["Params"] =
        Cookies.get("google_access_token") || Cookies.get("ask_access_token");
      return req;
    });

    this.basePath = `${this.praticheUrl}/api/sms-template`;
  }

  async getTemplates() {
    const res = await axios.get(`${this.basePath}/get`);
    return res.data;
  }

  async createTemplate(payload) {
    const res = await axios.post(`${this.basePath}/store`, payload);
    return res.data;
  }

  async updateTemplate(id, payload) {
    const res = await axios.put(`${this.basePath}/update/${id}`, payload);
    return res.data;
  }

  async deactivateTemplate(id) {
    const res = await axios.patch(`${this.basePath}/deactivate/${id}`);

    return res.data;
  }

  async deleteTemplate(id) {
    const res = await axios.delete(`${this.basePath}/delete/${id}`);
    return res.data;
  }
}
